import React, { memo, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Select, SubmissionButtons } from '@components/common';

import { menuOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EValidationMode } from '@enums/validationMode';

import { importSitesActions } from '@constants/common';

import { schema } from './schema';

import styles from './SitesImportForm.module.scss';

interface ISitesImportForm {
	onSubmit: (arg: {
		vendor: TSelectOption<string>;
		technology: TSelectOption<string>;
	}) => void;
	onClose: () => void;
	vendorsOptions: TSelectOption<string>[];
}

const SELECT_WIDTH = '240px';

type IImportFormValues = {
	vendor: TSelectOption<string>;
	technology: TSelectOption<string>;
};

const SitesImportForm = ({
	vendorsOptions,
	onClose,
	onSubmit,
}: ISitesImportForm) => {
	const technologiesOptions = useMemo(() => menuOptionsFormatted(importSitesActions), []);

	const {
		formState: { errors },
		handleSubmit,
		control,
	} = useForm<IImportFormValues>({
		mode: EValidationMode.onSubmit,
		resolver: yupResolver(schema),
		defaultValues: {
			technology: null,
			vendor: null,
		},
	});

	return (
		<>
			<div className={styles.selectWrapper}>
				<Select
					control={control}
					errorMessage={errors.vendor?.message}
					isClearable
					isError={!!errors?.vendor}
					label='Vendor'
					name='vendor'
					options={vendorsOptions}
					placeholder='Choose vendor'
					required
					width={SELECT_WIDTH}
				/>
				<Select
					control={control}
					errorMessage={errors.technology?.message}
					isClearable
					isError={!!errors?.technology}
					label='Technology'
					name='technology'
					options={technologiesOptions}
					placeholder='Choose technology'
					required
					width={SELECT_WIDTH}
				/>
			</div>
			<SubmissionButtons
				negativeHandler={onClose}
				positiveHandler={handleSubmit(onSubmit)}
				positiveLabel='Next'
			/>
		</>
	);
};

export default memo(SitesImportForm);
